<template lang="pug">
.modal_wrapper(:class='{ isShow: isShow }')
  .mask(v-if='isShow')
  .modal_content
    .modal_head
      .title {{ $t('bet_details') }}
      .close(@click='modalClose')
        img(:src='closeBtn')
    .modal_body(ref='modal_body')
      #detail_wrapper.detail_wrapper(ref='detail_wrapper')
        table.detail
          thead
            tr
              th.text_left(width='62px') {{ $t('serial_number') }}
              th.text_left(width='154px') {{ $t('bet_combination') }}
              th.text_left(width='154px') {{ $t('odds') }}
              th.text_right(width='154px') {{ $t('bet_money') }}
              th.text_right(width='154px') {{ $t('valid_bet') }}
              th.text_right(width='154px') {{ $t('payout_money') }}
              th.text_right(width='154px') {{ $t("rebate_money") }}
              th.text_right(width='154px')
                .row
                  .icon_wrapper(ref='icon_wrapper')
                    .icon(@click='isShow = !isShow')
                      .small ⅰ
                      input#icon_toggle(ref='icon_toggle', @blur='blur')
                    .outer(v-if='isShow', :style='point')
                      .arrow
                      div
                        p(v-html='$t("gameProfitRule")')
                  | {{ $t('game_profit_loss') }}
          tbody(v-if='Object.keys(details).length > 0')
            tr(v-for='(item, i) in details.list')
              //- 序號
              td {{ (pageNow - 1) * 50 + i + 1 }}
              //- 投注組合
              td
                .row
                  template(v-for='(num, index) in item.items')
                    .num {{ $t(addZero(num)) }}
                    template(v-if='index < item.items.length - 1') ,
              //- 賠率
              template(v-if="details.bet_info.odds_options")
                td.oddsValue
                  p
                    span(v-for="(it, idx) in details.bet_info.odds_options" :key="idx")
                      span(v-if="!idx") {{$t(translBetKeyFunc(it.key))}}
                      span(v-else) {{ ` / ${$t(translBetKeyFunc(it.key))}`}}
                  p
                    span(v-for="(it, idx) in details.bet_info.odds_options" :key="idx")
                      span(v-if="!idx") {{it.value}}
                      span(v-else) {{ ` / ${it.value}`}}
              td.oddsValue(v-else) {{ item.odds_value }}
              //- 投注金額
              td.text_right {{ showDecimal(item.bet_amount) }}
              //- 有效投注
              td.text_right {{ showDecimal(item.valid_amount) }}
              //- 派彩金額
              td.text_right {{ showDecimal(item.paid_amount) }}
              //- 返水金額
              td.text_right {{ showDecimal(item.rebate_amount) }}
              //- 遊戲損益
              td.text_right(:style='negativeNumberColor(item.back_profit_amount)') {{ showDecimal(item.back_profit_amount) }}
    .modal_foot(v-if='Object.keys(details).length > 0')
      .pagination
        .previous(@click='changePage("previous")') {{ '<' }}
        .moreBefore(v-if='pages[0] !== 1') …
        .page-item(
          v-for='(num, i) in pages',
          :class='[num === pageNow ? "selected" : ""]'
          @click='changePage(num)'
        ) {{ num }}
        .moreAfter(v-if='pages[pages.length - 1] !== pageTotal') …
        .next(@click='changePage("next")') {{ '>' }}
      .tips 共 {{ details.list.length }} 條
</template>

<script>
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  props: {
    orderId: {
      type: String,
      required: true
    },
    category: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      pageNow: 1,
      pageTotal: 1,
      details: [],
      isShow: false,
      scroll: 0,
      mouse: undefined
    }
  },

  computed: {
    closeBtn () {
      return require(`@/assets/icons/icon_close.svg`)
    },
    pages () {
      const now = this.pageNow
      const total = this.pageTotal
      const tempArray = Array(total > 5 ? 5 : total).fill(1).map((e, i) => {
        if (now > 3) {
          if (total === 4) {
            return i + 1
          }
          if (total - now > 2) {
            return now - 2 + i
          } else {
            return total - 4 + i
          }
        } else {
          return i + 1
        }
      })
      return tempArray
    },
    point () {
      if (Object.keys(this.details).length > 0) {
        const point = this.$refs.modal_body.getBoundingClientRect()
        const icon = this.$refs.icon_wrapper.getBoundingClientRect()

        return {
          top: `${icon.top - point.top}px`,
          left: `${icon.left - point.left}px`,
          Listener: this.scroll
        }
      }
      return {
      }
    },

    translBetKeyFunc () { // 翻譯
      return require('@/utils/translBetKeyToI18N/' + this.category + '.js').default
    }
  },

  watch: {
    isShow () {
      if (this.isShow) {
        document.getElementById('icon_toggle').focus()
        window.addEventListener('mousedown', this.mouseListener)
      } else {
        window.removeEventListener('mousedown', this.mouseListener)
      }
    }
  },

  created () {
    this.getBettingDetail()
  },

  mounted () {
    const self = this
    this.$refs.detail_wrapper.addEventListener('scroll', function () {
      self.scroll = document.getElementById('detail_wrapper').scrollLeft
    })
  },

  beforeDestroy () {
    const self = this
    this.$refs.detail_wrapper.removeEventListener('scroll', function () {
      self.scroll = document.getElementById('detail_wrapper').scrollLeft
    })
  },

  methods: {
    getBettingDetail () {
      const params = {
        order_id: this.orderId,
        per_page: 50,
        page: this.pageNow
      }
      this.$_AXIOS
        .post(`/v2/ml/record/sub/detail`, {
          ...params
        })
        .then(res => {
          this.details = res.data.data
          this.pageTotal = res.data.data.page_max
        })
        .catch(err => {
          console.error(err)
        })
    },
    changePage (event) {
      if (typeof event === 'number') {
        this.pageNow = event
      }
      if (
        event === 'previous' && this.pageNow > 1
      ) {
        this.pageNow -= 1
      }
      if (
        event === 'next' && this.pageNow < this.pageTotal
      ) {
        this.pageNow += 1
      }
      this.getBettingDetail()
    },
    addZero (num, event) {
      const { label } = this.details.bet_info
      if (label.includes('Tail') && event !== 'result') return `${num}尾`
      return num < 10 ? `0${num}` : num
    },
    modalClose () {
      this.$emit('modalClose')
    },
    blur () {
      if (this.$refs.icon_wrapper.contains(this.mouse)) {
        return this.$refs.icon_toggle.focus()
      }
      this.isShow = false
    },
    mouseListener (event) {
      this.mouse = event.target
    },
    negativeNumberColor (value) {
      const number = Number(value)
      if (isNaN(number)) return {}
      return {
        color: number < 0 ? 'red' : ''
      }
    }
  }
}
</script>

<style lang="stylus">
@import './DetailModal.styl'
</style>
